export default "__VITE_PUBLIC_ASSET__989e4399__"